import { useState } from "react";
import { ButtonGroup, reqDataType } from "components/ButtonGroup/ButtonGroup";
import { useAuth } from "context/auth-context";
import { ClaimedStudiesApproved } from "pages/ClaimedStudiesApproved/ClaimedStudiesApproved";
import { ClaimedStudiesRejected } from "../../pages/ClaimedStudiesRejected/ClaimedStudiesRejected";
import { ClaimedStudiesPending } from "pages/ClaimedStudiesPending/ClaimedStudiesPending";
import UnclaimedPanelistStudies from "pages/UnclaimedPanelistStudies/UnclaimedPanelistStudiesPage";
import LoadingOverlay from "react-loading-overlay-ts";
import { useTranslation } from "react-i18next";
import { PageHeader } from "components/ui";

const allButtons = [
  { id: 1, name: "Complete Studies" },
  { id: 4, name: "Pending Studies" },
  { id: 2, name: "Approved" },
  { id: 3, name: "Rejected" },
];

export const RedeemStudywisePage = () => {
  const userAuthenticationData = useAuth();
  const [reqData, setReqData] = useState<reqDataType>({
    panelListId: Number(userAuthenticationData?.auth?.panelistId),
    type: 1,
  });
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState<number>(1);
  console.log(currentPage);

  return (
    <LoadingOverlay
      styles={{
        overlay: (base) => ({
          ...base,
          position: "fixed",
          background: "rgb(var(--zs-overlay) / 0.45)",
        }),
      }}
      active={loading}
      spinner
      text={t("claim.card.Loading")}
    >
      <div className="zs-page">
        <PageHeader
          eyebrow="Rewards"
          title="Study rewards"
          subtitle="Claim points for the studies you completed and follow each claim from review to approval."
        />

        <div className="mb-4">
          <ButtonGroup
            reqData={reqData}
            setReqData={setReqData}
            setCurrentPage={setCurrentPage}
            userAuthenticationData={userAuthenticationData}
            allButtons={allButtons}
          />
        </div>

        <div className="min-w-0">
          {reqData?.type === 1 && <UnclaimedPanelistStudies setLoading={setLoading} />}
          {reqData?.type === 2 && <ClaimedStudiesApproved setLoading={setLoading} />}
          {reqData?.type === 3 && <ClaimedStudiesRejected setLoading={setLoading} />}
          {reqData?.type === 4 && <ClaimedStudiesPending setLoading={setLoading} />}
        </div>
      </div>
    </LoadingOverlay>
  );
};
